import React from 'react'
import { BaseClientConfig } from '../client/BaseClientConfig'

export const ConfigurationContext = React.createContext<BaseClientConfig>(
    undefined as any as BaseClientConfig,
)
